import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '分类浏览',
      links: [
        { label: '电影资源', to: '/category/movie' },
        { label: '电视剧资源', to: '/category/tv' },
        { label: '音乐资源', to: '/category/music' },
        { label: '软件资源', to: '/category/software' },
        { label: '文档资源', to: '/category/document' },
        { label: '游戏资源', to: '/category/game' },
      ],
    },
    {
      title: '热门推荐',
      links: [
        { label: '最新电影', to: '/category/movie' },
        { label: '无损音乐', to: '/category/music' },
        { label: '编程资源', to: '/category/document' },
        { label: '3A游戏大作', to: '/category/game' },
        { label: '热门综艺', to: '/category/variety' },
        { label: '动漫番剧', to: '/category/anime' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '联系我们', to: '/about' },
        { label: '使用指南', to: '/article/art-001' },
        { label: '下载提速技巧', to: '/article/art-005' },
      ],
    },
  ];

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-flashlight-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                  黑马磁力
                </span>
              </Link>
              <p className="text-foreground-400 text-sm leading-relaxed">
                专业的磁力链接搜索与资源发现平台。海量资源、精准搜索，让资源获取更简单、更快捷。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="GitHub">
                  <i className="ri-github-line"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((section) => (
              <div key={section.title}>
                <h4 className="font-heading text-base font-bold text-background-50 mb-4">{section.title}</h4>
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-foreground-400 hover:text-primary-400 text-sm transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-sm">
              &copy; {currentYear} 黑马磁力 Heimacili.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-foreground-500 hover:text-foreground-300 text-sm transition-colors">隐私政策</a>
              <a href="#" className="text-foreground-500 hover:text-foreground-300 text-sm transition-colors">服务条款</a>
              <a href="#" className="text-foreground-500 hover:text-foreground-300 text-sm transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}